import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { DiscoverV2BffService } from 'app/elements-v2/service/discover-v2-bff.service';
import { isAuthorizedInKeycloak, isStaffAuthorizedInKeycloak } from 'app/keycloak/reducers/keycloak.reducer';
import { setAvailableListPending } from 'app/list/actions/list.actions';
import { ListItem, ListWithItemsCount } from 'app/list/models/list';
import { getLists } from 'app/list/reducers/list.reducer';
import { ListSearchService } from 'app/list/services/list-search.service';
import { FeatureToggleService } from 'app/services/feature-toggle.service';
import { combineLatest, Subscription } from 'rxjs';
import { openBookmarksTab } from 'user/actions/user-profile.actions';

@Component({
  selector: 'app-searchable-bookmarks-results-preview-homepage',
  templateUrl: './searchable-bookmarks-results-preview-homepage.component.html',
  styleUrls: ['./searchable-bookmarks-results-preview-homepage.component.scss']
})
export class SearchableBookmarksResultsPreviewHomepageComponent implements OnInit, OnDestroy {
  public lists: ListWithItemsCount[] = [];
  public emptyLists: ListWithItemsCount[] = [];
  public listOpenCloseState = false;
  public authorized: boolean;
  public loading: boolean;
  public isStaffAuthorized: boolean;
  public count: number;
  public availableCount: number;
  public preview: ListItem[] = [];
  public flagActive = false;
  public bookmarksPreviewFlag = false;

  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly store: Store,
    private readonly listSearchService: ListSearchService,
    private readonly cdr: ChangeDetectorRef,
    private readonly featureToggleService: FeatureToggleService,
    private readonly discoverV2BffService: DiscoverV2BffService,
  ) {}

  ngOnInit() {
    this.flagActive = this.featureToggleService.getToggles()['VE-5396_2025-12-31_for_later_showcase_homepage'];
    this.loading = true;
    this.subscriptions.add(
      combineLatest([
        this.store.select(isAuthorizedInKeycloak),
        this.store.select(isStaffAuthorizedInKeycloak),
        this.store.select(getLists),
        this.discoverV2BffService.getPage(),
      ]).subscribe(([authorized, staffAuthorized, lists, page]) => {
        this.authorized = authorized || staffAuthorized;
        this.isStaffAuthorized = staffAuthorized;
        if (this.authorized && lists.length) {
          this.lists = JSON.parse(JSON.stringify(lists));
          this.preview = this.listSearchService.generateSearchPreview(this.lists.flatMap(l => l.items));
          this.loading = false;
          this.cdr.detectChanges();
        }
        if (page) {
          this.bookmarksPreviewFlag = page.settings.bookmarks_preview;
        }
      })
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public openAvailableList() {
    this.store.dispatch(setAvailableListPending({isPending: true}));
    this.store.dispatch(openBookmarksTab());
  }
}
